import React, { Component } from "react";
import styled from "styled-components";

const AddPic = styled.button`
  width: 100px;
  height: 100px;
  color: ${props => (props.color ? props.color : "white")};
  background-color: ${props => (props.bgColor ? props.bgColor : "#5186c2")};
  font-size: ${props => (props.fSize ? props.fSize : "16px")};
  font-weight: ${props => (props.fWeight ? props.fWeight : "normal")};
  text-decoration: ${props => (props.deco ? props.deco : "none")};
  border-radius: ${props => (props.bRadius ? props.bRadius : "50%")};
  cursor: pointer;
  :hover {
    color: ${props => (props.color ? props.color : "#97b2d1")};
  }
`;

class ButtonAddPicture extends Component {
  handleCLic() {
    console.log("clicked");
  }
  render() {
    const label = "Añadir foto";

    return <AddPic {...this.props} onClick={this.handleClic}>{label}</AddPic>;
  }
}

export default ButtonAddPicture;
